export default __webpack_public_path__ + "static/media/Loading_icon.1a32f552.gif";